
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import {
  ServicePageHero,
  ServiceProcess,
  ServiceTrust,
  ServiceContact,
} from '../../../components/feature';
import { ODOR_REMOVAL_DATA, SERVICE_FORM_ENDPOINT } from '../../../data/servicePageData';

export default function OdorRemovalPage() {
  const { title, subtitle, heroImage, processTitle, processSubtitle, steps } = ODOR_REMOVAL_DATA;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicePageHero title={title} subtitle={subtitle} backgroundImage={heroImage} />
      <ServiceProcess title={processTitle} subtitle={processSubtitle} steps={steps} />
      <ServiceTrust serviceName="Odor Removal" />
      <ServiceContact serviceName="Odor Removal" formEndpoint={SERVICE_FORM_ENDPOINT} />
      <Footer />
    </div>
  );
}
